import { PageProps, graphql } from 'gatsby';

import React from 'react';
import ReactMarkdown from 'react-markdown';
import { SEOArguments } from '../classes/seoArguments';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { LocalType } from '../models/localType';
import SEO from '../components/Seo';
import MainLayout from '../components/layout/MainLayout';

export const query = graphql`
    query AboutPage {
        metadata: allProductsJson(
            filter: { code: { eq: "century_a-propos" } }
        ) {
            nodes {
                code
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function About({ data }: PageProps<Queries.AboutPageQuery>) {
    const { currentLocale } = usePageLocalization();

    const attributes = data.metadata.nodes[0].attributes;
    const aboutContent = String(
        attributes?.content?.values?.[0]?.[currentLocale as keyof LocalType]
    );

    const seoArguments = new SEOArguments(
        data.metadata,
        currentLocale as keyof LocalType
    );

    return (
        <MainLayout>
            <SEO
                title={seoArguments.title}
                description={seoArguments.description}
            />
            <div className='container'>
                <div className='row about' style={{ textAlign: 'justify' }}>
                    <div id='primary'>
                        <ReactMarkdown>{aboutContent}</ReactMarkdown>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}
